import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { rewriteAccountLinksForSoftLogin } from "@utils/account";

import { SoftLoginService } from "@services/softLogin.service";

import { getCustomer } from "@redux/modules/api/data/customer/customer.selectors";

import { PageLinkProps } from "@components/General/PageLinks/PageLink/pageLink.component";

import { AccountLinks } from "./accountLinks.component";

export type AccountLinksContainerProps = {
    menuItems: Array<any>;
    profileLink: string;
};

const AccountLinksContainer = ({
    menuItems,
    profileLink,
}: AccountLinksContainerProps) => {
    const [accountLinks, setAccountLinks] = useState<
        Array<PageLinkProps> | undefined
    >([]);
    const customer = useSelector(getCustomer);
    const userIsLoggedIn =
        (customer && !customer.guest) || SoftLoginService.isSoftLoggedIn();

    useEffect(() => {
        const isLoggedIn = !!(customer && !customer.guest);
        const links = rewriteAccountLinksForSoftLogin(
            isLoggedIn,
            menuItems,
            profileLink,
        );
        setAccountLinks(links);
    }, [customer, menuItems]);

    return (
        <AccountLinks
            menuItems={accountLinks || []}
            profileLink={profileLink}
            isLoggedIn={userIsLoggedIn}
        />
    );
};

export default AccountLinksContainer;
